module.exports = __webpack_public_path__ + "img/atari1200_page13.5660a7c9.jpg";